import { devices_config } from '@devices/index';
import { rooms } from 'src/stores/lists/rooms';
import type { Device } from 'src/types/Device';
import { get } from 'svelte/store';

export const filterDevicesByRoom = (devices: Device[]): any[] => {
	let filteredDevicesByRoom: any = {};

	devices.forEach((device: Device) => {
		const roomID = device.room_id;
		const roomName = get(rooms)[roomID]?.name || 'Unknown room';

		const deviceData = {
			id: device.id,
			name: `${devices_config[device.type].friendly_name} (${device.name})`,
			image: device.image,
			backgroundColor: device.backgroundColor,
			roomName: roomName,
			roomID: roomID,
		};

		if (filteredDevicesByRoom[roomID]) {
			filteredDevicesByRoom[roomID] = {
				cards: [...filteredDevicesByRoom[roomID].cards, deviceData],
				roomName: roomName,
				roomID: roomID,
			};
		} else {
			filteredDevicesByRoom[roomID] = {
				cards: [deviceData],
				roomName: roomName,
				roomID: roomID,
			};
		}
	});

	return Object.values(filteredDevicesByRoom);
};
